import React, { PropsWithChildren, memo } from 'react'
import './element-clickable.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  icon?: string
  iconColor?: string
  rightIcon?: string
  rightIconColor?: string
  title: string
  fileDownload: Blob | string
  action?: () => void
}

export default ({
  className = '',
  title = '',
  icon = 'fa-regular fa-file-pdf',
  iconColor = 'var(--primary_color)',
  rightIcon = 'fa-regular fa-arrow-down-to-line',
  rightIconColor = 'var(--primary_color)',
  fileDownload,
  action = null,
}: Props) => {
  const ElementClickable = memo(({ children }: PropsWithChildren) => {
    if (action && typeof action === 'function') {
      return (
        <button className={`p-3 my-3 link-download ${className}`} onClick={() => action()}>
          {children}
        </button>
      )
    } else {
      return (
        <a
          className={`p-3 my-3 link-download ${className}`}
          href={typeof fileDownload !== 'string' ? window.URL.createObjectURL(fileDownload) : fileDownload}
          target="_blank"
        >
          {children}
        </a>
      )
    }
  })

  return (
    <ElementClickable>
      <i className={`mr-2 ${icon}`} style={{ fontSize: '2rem', fontWeight: 400, color: iconColor }}></i>
      <span className="justify-self-flex-start title-link">{title}</span>
      <i className={`fa-regular ${rightIcon}`} style={{ fontSize: '2rem', fontWeight: 400, color: rightIconColor }}></i>
    </ElementClickable>
  )
}
